import React, { useRef } from "react";

import { Transition } from "@headlessui/react";
import { TransitionGroup, CSSTransition } from "react-transition-group";

export const ContainerFluid = ({ children, trigger }) => {
  const childRef = useRef();

  return (
    <TransitionGroup
      appear={true}
      className="arh-h-[100%]"
    >
      <CSSTransition
        key={trigger}
        timeout={300}
        classNames="fade"
        nodeRef={childRef}
        exit={false}
      >
        <div
          ref={childRef}
          className="arh-h-[100%]"
        >
          {children}
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};

/**
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {string=} props.superZIndex
 * @param {any=} props.children
 * @returns
 */
export const DisclosureContentFluid = ({ children, open, superZIndex }) => {
  return (
    <div className={superZIndex}>
      <Transition
        show={open}
        // enter="arh-transition arh-duration-70 arh-ease-out"
        // enterFrom="arh-transform arh-scale-[0.99] arh-opacity-0"
        // enterTo="arh-transform arh-scale-100 arh-opacity-100"
        // leave="arh-transition arh-duration-70 arh-ease-out"
        // leaveFrom="arh-transform arh-scale-70 arh-opacity-100"
        // leaveTo="arh-transform arh-scale-[0.99] arh-opacity-0"
        unmount={false}
      >
        {children}
      </Transition>
    </div>
  );
};
